<om-fade
  [direction]="'up'"
  [transitionDuration]="'0.5s'"
  [transitionFunction]="'ease-in'"
  [animateOnlyOnce]="true"
>
  <div class="container">
    <div class="platform-header">
      <div class="ph-right">
        <h2>
          {{ heading1 }}
          <om-gradient-text
            [text]="heading2"
            [gradientStart]="'rgba(0, 102, 253, 1)'"
            [gradientEnd]="'rgba(239, 72, 253, 1)'"
            styleClass="custom-gradient-text"
          ></om-gradient-text
          ><om-gradient-text
            [text]="heading3"
            [gradientStart]="'rgba(0, 102, 253, 1)'"
            [gradientEnd]="'rgba(239, 72, 253, 1)'"
            styleClass="custom-gradient-text"
          ></om-gradient-text>
          {{ heading4 }}
        </h2>
      </div>
      <div class="ph-left">
        <a routerLink="/four-pillars" class="learn-more">{{ subheading }}</a>
      </div>
    </div>
    <div class="cards-container">
      <div class="card" *ngFor="let card of array; let i = index">
        <div class="card-image">
          <div
            class="background-image"
            [style.background-image]="'url(' + card.imageUrl + ')'"
          ></div>
        </div>
        <div class="card-text">
          <h2>{{ card.number }}</h2>
          <h3 class="card-title">{{ card.heading }}</h3>
          <p class="card-description">{{ card.description }}</p>
        </div>
      </div>
    </div>
    <div class="action-btn">
      <a routerLink="/four-pillars" class="learn-more">{{ subheading }}</a>
    </div>
    <!-- <div class="bottom-right-circle"></div> -->
  </div>
</om-fade>
